import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const cardImgContainer = style({
  backgroundColor: themeVars.container.secondary.background.idle,
  borderTopLeftRadius: space.s16,
  borderTopRightRadius: space.s16,

  overflow: 'hidden',
});

export const cardImg = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
});
